import { CbhFeatureFlag } from "../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../FeatureFlags/useCbhFlag";

export function useIsSurfaceShiftsEnabled() {
  return useCbhFlag(CbhFeatureFlag.SURFACE_SHIFTS, {
    defaultValue: false,
  });
}
